import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

export const Counter = () => {
  const getTargetTime = () => {
    const now = new Date();
    const target = new Date(now);

    if (now.getHours() >= 12) {
      target.setHours(24, 0, 0, 0); 
    } else {
      return null;
    }

    return target;
  };

  const calculateTimeLeft = () => {
    const targetTime = getTargetTime();

    if (!targetTime) {
      return null;
    }

    const now = new Date();
    const difference = targetTime - now;

    if (difference <= 0) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const newTime = calculateTimeLeft();
      setTimeLeft(newTime);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Si no se debe mostrar el contador (antes de las 12 PM)
  if (!timeLeft) return null;

  const formatTime = (value) => (value < 10 ? `0${value}` : value);

  return (
    <>
      <div className='container-counter-general'>
        <div className='container-counter  container-100'>
          <Link to={`/#`} className='container-othercategories pointer position-relative flex-container flex-center align-center'>
            {/* sliders */}
            <img
              src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=contador-banner.png&version_id=null"
              alt={`contador desktop`}
              className="img-responsive position1 countersm"
            />
            <img
              src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=contador-bannerxs.png&version_id=null"
              alt={`contador mobile`}
              className="img-responsive card-image-xs position1 counterxs"
            />

            {/* elementos del contador */}
            <div className='fondo1 flex-box flex-end custom-body position2 position-absolute container-100'>
              <div className='fondo2 flex-center'>
                <div className='font20 txt-semibold colorfff font-title'>Termina en</div>
                <div className="flex-center flex-box font40 txt-semibold font-numbers">
                  <div className="">
                    <div className=" box-hour align-center color-520FDA">{formatTime(timeLeft.hours)} </div>
                    <div className="box-hour-lbl align-center colorfff container-100">HRS</div>
                  </div>
                  <div className="colorfff two-points two-points-counterxs">:</div>
                  <div className="">
                    <div className=" box-hour align-center color-520FDA">{formatTime(timeLeft.minutes)}</div>
                    <div className="box-hour-lbl align-center colorfff container-100">MIN</div>
                  </div>
                  <div className="colorfff two-points">:</div>
                  <div className="">
                    <div className="box-hour align-center color-520FDA">{formatTime(timeLeft.seconds)}</div>
                    <div className="box-hour-lbl align-center colorfff container-100">SEG </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>


        </div>
      </div>

      {/*}
      <div className='hidemax700'>
        <Link to={`/#`} className='container-othercategories'>
          <img
            src="https://lh3.google.com/u/1/d/1nRaahTXBdCAv8Km1uDfnbfFScsqxiMWP=w1920-h868-iv1"
            alt={`contador`}
            className="img-responsive card-image-xs position1"
          />
        </Link>
        
        <div className='fondo1 flex-box flex-end custom-body position2'>
          <div className='fondo2 flex-center'>
            <div className='font20 txt-semibold colorfff'>Termina en</div>
            <div className='flex-center flex-box font40 txt-semibold '>
              <div className='box-hour align-center color-520FDA'>{timeLeft.hours} </div>
              <div className='colorfff two-points'>:</div>
              <div className='box-hour align-center color-520FDA'>{timeLeft.minutes}</div>
              <div className='colorfff two-points'>:</div>
              <div className='box-hour align-center color-520FDA'>{timeLeft.seconds}</div>
            </div>
            <div className='flex-center flex-box font19 txt-semibold '>
              <div className='box-hour-lbl align-center colorfff'>Hrs</div>
              <div className='colorfff '> </div>
              <div className='box-hour-lbl align-center colorfff'>Min </div>
              <div className='colorfff'> </div>
              <div className='box-hour-lbl align-center colorfff'>Seg </div>
            </div>
          </div>
        </div>
      </div>
      */}
    </>
  )
}
